import useTranslation from 'next-translate/useTranslation';

// Lib
import type { DatepickerComparisonPeriodsAvailableType } from '@/lib/periods';
import { PREVIOUS_PERIOD, SAME_PERIOD_LAST_YEAR } from '@/lib/periods';

// Components
import Select from '@/components/base/Select';

export type DatepickerCompareToProps = {
    onChange: (args: { label: string; value: DatepickerComparisonPeriodsAvailableType }) => void;
    compareTo: DatepickerComparisonPeriodsAvailableType;
};

const DatepickerCompareTo = ({ onChange, compareTo }: DatepickerCompareToProps) => {
    const { t } = useTranslation('commons');

    const dataCompareTo = [
        { label: t('datepicker.previous_period'), value: PREVIOUS_PERIOD },
        { label: t('commons:datepicker.same_period_last_year'), value: SAME_PERIOD_LAST_YEAR }
    ];

    return (
        <div className="mt-3">
            <Select
                placement="top"
                selected={dataCompareTo.filter((item) => compareTo === item.value)[0]}
                setSelected={onChange}
                label={t('commons:datepicker.compare_to')}
                options={dataCompareTo}
            />
        </div>
    );
};

export default DatepickerCompareTo;
